import { trimUptoTwoDecimals } from '@Pages/RetroSynthesis/utils';
import { buildStepsDataFromRouteLayout } from './stepsDataBuilder';

const buildTableFromList = (routeLayout) => {
  const mapperFunc = (stepObj, item, children) => {
    const { confidence } = stepObj;
    const { substance } = item;
    return {
      ...stepObj,
      ...(confidence && {
        confidence: trimUptoTwoDecimals(confidence),
      }),
      substance,
      startingMaterials: children && children.reduce((memo, { substance: childSubstance }) => [...memo, childSubstance], []),
    };
  };

  return buildStepsDataFromRouteLayout(routeLayout, mapperFunc);
};

export default buildTableFromList;
